"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "vallelaghi": {
    "c751e045": [{
      "hkey": "d2e9a34d",
      "slug": "vallelaghi",
      "name": "Vallelaghi",
      "primary": true,
      "skipSearch": false
    }],
    "falesina": [{
      "hkey": "d2e9a34d",
      "slug": "vallelaghi",
      "name": "Vallelaghi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "73ee9041": [{
      "hkey": "d2e9a34d",
      "slug": "vallelaghi",
      "name": "Vallelaghi",
      "primary": true,
      "skipSearch": false
    }],
    "fraveggio": [{
      "hkey": "d2e9a34d",
      "slug": "vallelaghi",
      "name": "Vallelaghi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e256fc14": [{
      "hkey": "d2e9a34d",
      "slug": "vallelaghi",
      "name": "Vallelaghi",
      "primary": true,
      "skipSearch": false
    }],
    "vignola": [{
      "hkey": "d2e9a34d",
      "slug": "vallelaghi",
      "name": "Vallelaghi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;